import React from 'react'
import ShowDesignMetaDetail from "./show-design-meta-detail";

const ShowDesignDetail = ({designDetail}) => {

    return (
        <>
            <div className="text-xl mr-4 ml-1">
                {designDetail?.name}
            </div>
            <div className="flex justify-start items-center">
                {designDetail?.podName &&
                    <div className="pill pill-purple">
                        {designDetail?.podName}
                    </div>
                }

                {designDetail?.productType &&
                    <div className="pill pill-purple">
                        {designDetail?.productType}
                    </div>
                }

                {designDetail?.category &&
                    <div className="pill pill-purple">
                        {designDetail?.category}
                    </div>
                }

                <ShowDesignMetaDetail designDetail={designDetail}/>
            </div>
        </>
    )
}

export default ShowDesignDetail
